export default __webpack_public_path__ + "398c8d7aca0ea4b11731d01efe4d57f1.jpg";